module.exports = __webpack_public_path__ + "img/animate.8116cce9.gif";